// export const BASEURL = "https://api-test.rtosoftware.com.au/api/";
//export const BASEURL = "https://lmsapi.rtosoftware.com.au/api/";
// export const BASEURL = "https://localhost:5003/api/";
//export const BASEURL = "https://testapi.rtosoftware.com.au/api/";
//export const BASEURL = "http://192.168.18.22/api/";
//export const COLLEGEID = 20260;
export const BASEURL = window.configs.collegeName == "localhost" ? "https://localhost:5003/api/" : "https://api-" + window.configs.collegeName + "." + (window.configs.domainName || "rtosoftware.com.au") + "/api/";
export const COLLEGEID = 301;

// Program Types
export const CURRENTPROGRAM = 1;
export const PASTPROGRAM = 2;

// Table Constants
export const NUMBEROFROWS = 50;

export const defaultDataTiles = [
  {
    label: "Pending Applications",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-sky-500 dark:text-sky-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    link: "/dashboard/PendingApplications",
    data: "",
    bgColorClasses: "text-sky-600 bg-sky-100 dark:text-sky-300 dark:bg-sky-900/40"
  },
  {
    label: "Overdue Fees",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-rose-500 dark:text-rose-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    link: "/dashboard/overDues",
    bgColorClasses: "text-rose-600 bg-rose-100 dark:text-rose-300 dark:bg-rose-900/40"
  },
  {
    label: "Communications",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-violet-500 dark:text-violet-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    link: "/dashboard/communications",
    bgColorClasses: "text-violet-600 bg-violet-100 dark:text-violet-300 dark:bg-violet-900/40"
  },
  {
    label: "Documents",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-amber-500 dark:text-amber-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"></path>
        <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"></path>
      </svg>
    ),
    link: "/dashboard/documents",
    viewBox: "0 0 24 24",
    bgColorClasses: "text-amber-600 bg-amber-100 dark:text-amber-300 dark:bg-amber-900/40"
  },
  {
    label: "Active Enrolments",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-emerald-500 dark:text-emerald-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"></path>
      </svg>
    ),
    link: "/dashboard/ActiveEnrolments",
    viewBox: "0 0 24 24",
    bgColorClasses: "text-emerald-600 bg-emerald-100 dark:text-emerald-300 dark:bg-emerald-900/40"
  },
  {
    label: "Commissions Due",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-orange-500 dark:text-orange-400"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.854,12.481c-0.735-0.46-1.758-0.881-3.068-1.264c-1.31-0.382-2.251-0.807-2.822-1.276 C9.392,9.474,9.106,8.845,9.106,8.056c0-0.85,0.271-1.514,0.813-1.989c0.541-0.476,1.323-0.713,2.345-0.713 c0.979,0,1.758,0.321,2.333,0.964c0.576,0.643,0.864,1.51,0.864,2.601L15.46,9h2.372l0.001-0.08c0-1.582-0.401-2.829-1.205-3.74 c-0.804-0.91-1.927-1.455-3.371-1.632L13.25,3.547V1h-2v2.551C9.858,3.716,8.756,4.19,7.953,4.983 C7.132,5.794,6.721,6.832,6.721,8.098c0,1.243,0.419,2.268,1.257,3.075c0.838,0.806,2.172,1.461,4.002,1.963 c1.315,0.394,2.249,0.834,2.804,1.32c0.553,0.487,0.831,1.085,0.831,1.795c0,0.842-0.323,1.506-0.967,1.992 c-0.645,0.486-1.53,0.729-2.656,0.729c-1.151,0-2.041-0.289-2.668-0.868s-0.94-1.405-0.94-2.478H6c0,1.528,0.453,2.738,1.359,3.63 c0.883,0.869,2.101,1.37,3.641,1.517V23h2v-2.21l0.025-0.001c1.572-0.147,2.795-0.617,3.667-1.413 C17.563,18.581,18,17.531,18,16.227c0-0.818-0.175-1.532-0.522-2.143C17.13,13.475,16.588,12.94,15.854,12.481z"></path>
      </svg>
    ),
    link: "/dashboard/commissionDue",
    viewBox: "0 0 24 24",
    bgColorClasses: "text-orange-600 bg-orange-100 dark:text-orange-300 dark:bg-orange-900/40"
  },
  {
    label: "Future Commissions",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-5 h-5 fill-current text-indigo-500 dark:text-indigo-400"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"></path>
        <path
          fillRule="evenodd"
          d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    link: "/dashboard/FutureCommission",
    viewBox: "0 0 24 24",
    bgColorClasses: "text-indigo-600 bg-indigo-100 dark:text-indigo-300 dark:bg-indigo-900/40"
  },
  {
    label: "Paid Commissions",
    value: "",
    description: "Loading...",
    svg: (
      <svg
        className="w-6 h-6 fill-current text-teal-600 dark:text-teal-400"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.963 3A1 1 0 0 0 12 4v22h-2c-2.195 0-4 1.805-4 4v16a1 1 0 1 0 2 0V30c0-1.105.895-2 2-2h2v2c-1.105 0-2 .895-2 2s.895 2 2 2h26c1.105 0 2-.895 2-2s-.895-2-2-2v-2h2c1.105 0 2 .895 2 2v16a1 1 0 1 0 2 0V30c0-2.195-1.805-4-4-4h-2V4a1 1 0 0 0-1.447-.895L35 3.883l-1.553-.778a1 1 0 0 0-.894 0L31 3.883l-1.553-.778a1 1 0 0 0-.894 0L27 3.883l-1.553-.778a1 1 0 0 0-.894 0L23 3.883l-1.553-.778a1 1 0 0 0-.894 0L19 3.883l-1.553-.778a1 1 0 0 0-.894 0L15 3.883l-1.553-.778a1 1 0 0 0-.484-.105zM17 5.117l1.553.778a1 1 0 0 0 .894 0L21 5.117l1.553.778a1 1 0 0 0 .894 0L25 5.117l1.553.778a1 1 0 0 0 .894 0L29 5.117l1.553.778a1 1 0 0 0 .894 0L33 5.117l1.553.778a1 1 0 0 0 .894 0L36 5.617V32H14V5.617l.553.278a1 1 0 0 0 .894 0L17 5.117zM24 9v2.221c-1.6.26-2.789.923-3.336 1.757C19.997 13.997 20 15.053 20 15.053c0 1.429.859 2.532 1.873 3.172 1.014.64 2.198.992 3.316 1.357 1.118.365 2.164.742 2.832 1.207.668.465.979.876.979 1.756 0 0 .004.533-.436 1.14C28.125 24.293 27.27 25 25 25c-2.233 0-3.061-.783-3.527-1.529C21.006 22.725 21 22 21 22h-2s-.007 1.275.777 2.529c.667 1.067 2.142 1.956 4.223 2.242V29h2v-2.197c2.045-.244 3.497-.994 4.186-1.946C30.996 23.737 31 22.545 31 22.545c0-1.508-.815-2.686-1.834-3.397-1.019-.71-2.223-1.097-3.355-1.467-1.132-.37-2.198-.724-2.872-1.149C22.266 16.108 22 15.789 22 15.053c0 0 .004-.471.336-.978C22.668 13.567 23.254 13 25 13c1.75 0 2.339.561 2.668 1.055C27.997 14.549 28 15 28 15h2s.003-1.049-.668-2.055c-.549-.824-1.736-1.473-3.332-1.728V9h-2zM12 37a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6zm10 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6zm10 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6zm-20 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6zm10 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6zm10 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-6z" />
      </svg>
    ),
    link: "/dashboard/paidCommissionsView",
    viewBox: "0 0 24 24",
    bgColorClasses: "text-teal-600 bg-teal-100 dark:text-teal-300 dark:bg-teal-900/40"
  },
];

export const startDateKeys = [
  "t1StartDate",
  "t2StartDate",
  "t3StartDate",
  "t4StartDate",
  "t5StartDate",
  "t6StartDate",
  "t7StartDate",
  "t8StartDate",
];
export const endDateKeys = [
  "t1EndDate",
  "t2EndDate",
  "t3EndDate",
  "t4EndDate",
  "t5EndDate",
  "t6EndDate",
  "t7EndDate",
  "t8EndDate",
];

export const VALIDVISATYPESFORCHECKBOX = [
    "student visa 570",
    "student visa 571",
    "student visa 572",
    "student visa 573",
    "student visa 574",
    "student visa 575",
    "student visa 576",
    "student visa",
    "student visa (subclass 500)",
]

export const AGENT_CHANGE_URL = BASEURL + "AgentChangeInfo";
export const CURRENT_USER_DATA_URL = BASEURL + "AgentChangeInfo/" + localStorage.getItem("agentId");
export const LAST_REQUEST_STATUS = BASEURL + "AgentChangeInfo/LastRequest/" + localStorage.getItem("agentId");
export const ALL_REQUEST_STATUS = BASEURL + "AgentChangeInfo/GetAllRequests/" + localStorage.getItem("agentId");
export const CANCEL_AGENT_REQUEST = BASEURL + "AgentChangeInfo/CancelRequest";
export const CITY_SUBURB_SUGGESTION_URL = BASEURL + "AgentChangeInfo/Suburb?name=";
export const UPDATE_AGENT_PASSWORD = BASEURL + "Agents/UpdateAgentPassword";
